import { markUpsellAsInteracted } from '#pplx/frontend/apps/ask/queries/upsell-queries/markUpsellAsInteracted.js';
import { isCtaEnabledForDeployment } from '#pplx/frontend/apps/ask/upsell-slots/actions/ctaCapabilities.js';
import { trackUpsellActionEvent } from '#pplx/frontend/apps/ask/upsell-slots/actions/internal/trackUpsellActionEvent.js';
import { logger } from '#pplx/frontend/logger/browser.js';
export const executeUpsellSlotAction = async ({ customHandlers, inFlight, selectedActionOptionId, interactionType, onCreditsPurchased, runtime, upsellInformation, }) => {
    if (!upsellInformation) {
        return;
    }
    if (upsellInformation.cta && !isCtaEnabledForDeployment(upsellInformation.cta))
        return;
    const upsellInstanceIdentifier = upsellInformation.cta === 'SHORTCUT_MODAL'
        ? upsellInformation.cta_information?.recommended_shortcut?.name
        : undefined;
    if (interactionType === 'dismiss') {
        const markInteractionPromise = markUpsellAsInteracted({
            upsellName: upsellInformation.name,
            upsellUUID: upsellInformation.upsell_uuid,
            upsellInstanceIdentifier,
            interactionType: 'dismiss',
        });
        runtime.hideUpsell?.();
        await markInteractionPromise;
        return;
    }
    if (upsellInformation.app_location !== 'MODAL') {
        markUpsellAsInteracted({
            upsellName: upsellInformation.name,
            upsellUUID: upsellInformation.upsell_uuid,
            upsellInstanceIdentifier,
            interactionType: 'click',
        });
    }
    const selectedActionOption = upsellInformation.action_options?.find((option) => selectedActionOptionId !== undefined && option.id === selectedActionOptionId);
    trackUpsellActionEvent({ runtime, upsellInformation, selectedActionOption });
    const ctx = {
        upsellInformation,
        firstResult: runtime.firstResult,
        selectedActionOption,
        lastResult: runtime.lastResult,
        origin: runtime.origin,
        retryQueryParam: runtime.retryQueryParam,
        inFlight,
        queryClient: runtime.queryClient,
        getStripePromise: runtime.getStripePromise,
        router: runtime.router,
        openModal: runtime.openModal,
        openToast: runtime.openToast,
        $t: runtime.$t,
        track: runtime.track,
        cometAdapter: runtime.cometAdapter,
        connectors: runtime.connectors,
        connectorActionPageHref: runtime.connectorActionPageHref,
        handleConnect: runtime.handleConnect,
        handleDisconnect: runtime.handleDisconnect,
        sources: runtime.sources,
        overwriteSources: runtime.overwriteSources,
        hideUpsell: runtime.hideUpsell,
        onCreditsPurchased,
        sendSubscribedEventSingular: runtime.sendSubscribedEventSingular,
        isMedicalRecordsEnabled: runtime.isMedicalRecordsEnabled,
        hasActiveSubscription: runtime.hasActiveSubscription,
        openVisitorLoginUpsell: runtime.openVisitorLoginUpsell,
        openPaywallUpsell: runtime.openPaywallUpsell,
        handleClickPersonal: runtime.handleClickPersonal,
        handleVerificationSuccess: runtime.handleVerificationSuccess,
        handleCreateNewSpaceForThread: runtime.handleCreateNewSpaceForThread,
        submitQuery: runtime.submitQuery,
        setConfiguredModel: runtime.setConfiguredModel,
        setUserInput: runtime.setUserInput,
        submitComputerTask: runtime.submitComputerTask,
        handleCometDownloadClick: runtime.handleCometDownloadClick,
        openMergeLink: runtime.openMergeLink,
        requestLocation: runtime.requestLocation,
        openBrowserExtensionInstall: runtime.openBrowserExtensionInstall,
        hardLoginGateVariation: runtime.hardLoginGateVariation,
    };
    if (upsellInformation.cta != null) {
        const customHandler = customHandlers?.[upsellInformation.cta];
        if (customHandler) {
            await customHandler(ctx);
            return;
        }
        const handled = await runtime.executeCtaHandler(ctx);
        if (handled) {
            return;
        }
    }
    if (upsellInformation.cta === 'ALLOW_CONNECTOR_AUTH') {
        void runtime.handleAllowConnectorAuthAction(upsellInformation);
        return;
    }
    logger.warn('Unhandled upsell CTA', { cta: upsellInformation.cta });
};
//# sourceMappingURL=executeUpsellSlotAction.js.map